/*eslint no-script-url: 0 */
import React, { Component } from "react";
import MatViewSelection from './MatViewSelection';

class MatSizeSelection extends Component {

	constructor(props) {
		super(props);
		this.state = {
			matSizes: [
		        0,
		        1,
		        2,
		       	3
		    ]
		}
		this.handleMatsViewChange = this.handleMatsViewChange.bind(this);
	}

	handleMatSizeChange(event) {
		this.handleMatsViewChange(event.target.value);
	}

	handleMatsViewChange(size) {
		this.props.dispatch({
			type: 'SET_STATE',
			state: {
				selectedMatSize: size
			}
	    });
	}

 	render() {
 		const options = this.state.matSizes.map((size, key) => {
	      	const isCurrent = parseFloat(this.props.selectedMatSize) === parseFloat(size)
			return (
				<div key={key} className="col-sm-3 col-xs-6 m-b-5">
					<label 
						className={
							isCurrent ? 
							'radioPad__wrapper radioPad__wrapper--selected' :
							'radioPad__wrapper'
						}
					>
						<input
							className="radioPad__radio"
							type="radio" 
							name="mats" 
							id={size}
							value={size}
							onClick={this.handleMatSizeChange.bind(this)} />
						{size}
					</label>
				</div>
			)
	    })

	    return (
	    	<div className="col-sm-5">
	 				<div className="choose-mat-size">
					<form>
						<h4 className="card-title">
							How many mats would you like?
						</h4>
						<br/>
						<div className="row">
							{options}
						</div>
					</form>
				</div>
				<div className="m-t-10">
					<MatViewSelection
						{...this.props}
						handleMatsViewChange={this.handleMatsViewChange} />
				</div>
			</div>
		);
  	}
}
 
export default MatSizeSelection;